import Vue from 'vue';
import moment from "moment";

import {
  FILES_SET,
} from '../mutations-types'

const state = {
  uploadedCustomFile: null,
};

const getters = {
  uploadedCustomFile: state => state.uploadedCustomFile,
};

const mutations = {
  [FILES_SET](state, data) {

    Vue.set(state, 'uploadedCustomFile', data );
  },
};

const actions = {
  /**
   * @note
   * require auth
   * @URLParams
   * none
   * @BodyParams
   * file:       file, required
   * listing_id: integer, required
   * type:       string, required
   * date:       string, required
   * **/
  FILES_REQUEST_SET ({ state, commit }, data) {
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('listing_id', data.listing_id);
    formData.append('type', data.type);
    formData.append('date', moment().format('YYYY-MM-DD'));

    return new Promise((resolve, reject) => {
      Vue.axios.post('/document', formData)
        .then(response => {
          commit(FILES_SET, response.data );
          resolve();
        }).catch(error => {
          reject();
        });
    });
  },

  /**
   * @note
   * require auth
   * @URLParams
   * documentId: integer, required
   * @BodyParams
   * none
   * **/
  FILES_REQUEST_DELETE ({ state, commit }, documentId) {
    return new Promise((resolve, reject) => {
      Vue.axios.delete('/document/' + documentId)
        .then(response => {
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};